import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
const StyledTHead = styled.thead.withConfig({
  componentId: "sc-1j5j77q-0"
})([""]);

const THead = ({
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(StyledTHead, props, children);
};

export { StyledTHead };
export default THead;
THead.propTypes = {
  /** The table head contents. */
  children: PropTypes.node
};